<div class="container-xxl">
    <div class="row g-0">
        <div class="col-12 col-md-6">
            <div class="extend-l h-100 full-md-center full-md-vw">
                <div class="h-100 overflow-hidden">
                    <img class="min-w-100 min-h-100 img-fluid item-md-center" src="/assets/images/image_1.png" alt="" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 d-flex flex-column justify-content-center px-lg-12 px-md-7 px-sm-9 py-10 py-md-0">
            <div class="py-8">
                <p class="text-uppercase fs-12 fw-700 font-secondary ls-3">{{ 'CONFIGURATOR.title' | translate }}</p>
                <h2 class="fs-32 lh-48 text-primary fw-700 mb-5">{{ 'CONFIGURATOR.teaser' | translate }}</h2>
                <p class="mb-5 lh-29">{{ 'CONFIGURATOR.content' | translate }}</p>
                <h5>{{ 'CONFIGURATOR.subheader' | translate }}</h5>
                <p>{{ 'CONFIGURATOR.content_full_p1' | translate }}</p>

                <ul class="configurator-list mb-3">
                    @for (item of list; track item) {
                        <li>{{ item }}</li>
                    }
                </ul>

                <p>{{ 'CONFIGURATOR.content_full_p2' | translate }}</p>
                <p>{{ 'CONFIGURATOR.content_full_p3' | translate }}</p>
                <app-button color="secondary" [url]="['configurator'] | localize">{{ 'BUTTONS.create_project' | translate }}</app-button>
            </div>
        </div>
    </div>
</div>
